import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { NorthEast } from '@mui/icons-material';
import buildingIcon from '../../assets/building.png';
import { propertyCardStyles } from './PropertyCard.styles';

const PropertyCard = ({
  image,
  buildingIcon: customBuildingIcon,
  title,
  subtitle,
  price,
  currency,
  chips = []
}) => {
  const styles = propertyCardStyles();
  const buildingIconSrc = customBuildingIcon || buildingIcon;

  return (
    <Box sx={styles.container}>
      <Box sx={styles.imageContainer}>
        <Box
          component="img"
          src={image}
          alt="Property"
          loading="lazy"
          sx={styles.image}
        />
        <IconButton
          sx={styles.iconButton}
          aria-label="View property"
        >
          <NorthEast sx={styles.arrowIcon} />
        </IconButton>
      </Box>

      <Box sx={styles.buildingRow}>
        <Box sx={styles.buildingIconContainer}>
          <Box
            component="img"
            src={buildingIconSrc}
            alt="Building"
            loading="lazy"
            sx={styles.buildingIcon}
          />
        </Box>
        <Box sx={styles.buildingTextContainer}>
          <Typography sx={styles.buildingTitle}>
            {title}
          </Typography>
          <Typography sx={styles.buildingSubtitle}>
            {subtitle}
          </Typography>
        </Box>
      </Box>

      <Box sx={styles.priceRow}>
        <Typography sx={styles.price}>
          {price}
        </Typography>
        <Typography sx={styles.currency}>
          {currency}
        </Typography>
        <Typography sx={styles.perNight}>
          per night
        </Typography>
      </Box>

      <Box sx={styles.chipsContainer}>
        {chips.map((chip, index) => {
          const ChipIcon = chip.icon;
          const isImageIcon = typeof ChipIcon === 'string';
          
          return (
            <Box key={index} sx={styles.chip}>
              {isImageIcon ? (
                <Box
                  component="img"
                  src={ChipIcon}
                  alt=""
                  loading="lazy"
                  sx={styles.chipIcon}
                />
              ) : ChipIcon ? (
                <ChipIcon sx={styles.chipIcon} />
              ) : null}
              <Typography sx={styles.chipText}>
                {chip.text}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PropertyCard;

